import React from 'react'
import Spinner from "react-bootstrap/Spinner";

const Loading = () => {
    return  <div style={{display: "flex", height: "100%", justifyContent: "space-around"}}>
        <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around"}}>
            <Spinner style={{color:"rgb(16, 142, 115)", width: "50px", height: "50px"}} animation="border" role="status"/>
        </div>
    </div>
}

export default (Loading)
